<mat-card style="min-height:420px; max-height: 420px">
    <mat-card-content>
        <h4 class="mb-32 fw-bold">{{'SCHOOL_PROGRAM_CATEGORY_CHART'|translate}}</h4>

        <div class="max-width">
            <div class="form-group row">
                <div class="col-md-6">
                    <app-select-school-level-relation-v2 (schoolLevelRelationChanged)="onChangeSchoolLevelRelation($event)"
                                                         [academic_year]="academic_year"
                                                         [all]="false"
                                                         [isDisabled]="!academic_year">
                    </app-select-school-level-relation-v2>
                </div>
            </div>
        </div>
        <div *ngIf="!hasData && !loading"  class="d-flex justify-content-center align-items-center mt-4 mb-5" style="height:30vh">
            <h3>{{'NO_DATA_AVAILABLE'|translate}}</h3>
        </div>
        <div *ngIf="!hasData && loading" class="d-flex justify-content-center align-items-center mb-5" style="margin-top: 50px">
            <mat-spinner></mat-spinner>
        </div>
        <div id="chart" *ngIf="hasData && !loading && chartOptions">
            <apx-chart
                    [series]="chartOptions.series"
                    [chart]="chartOptions.chart"
                    [labels]="chartOptions.labels"
                    [responsive]="chartOptions.responsive"
            ></apx-chart>
        </div>
    </mat-card-content>
</mat-card>
